module.exports = __webpack_public_path__ + "img/integral_1.ae01ada2.png";